import { render } from "./stock_return_report_table.vue?vue&type=template&id=dd8fa4f2&scoped=true"
import script from "./stock_return_report_table.vue?vue&type=script&lang=js"
export * from "./stock_return_report_table.vue?vue&type=script&lang=js"

import "./stock_return_report_table.vue?vue&type=style&index=0&id=dd8fa4f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8fa4f2"]])

export default __exports__